import React from 'react';
import Styles from './Order.module.css';

const order = props => {
	const ingredients = [];

	for(let ingredientName in props.ingredients) {
   ingredients.push({name:ingredientName, 
   	              amount: props.ingredients[ingredientName]})
	}
   
const ingredientOutput = ingredients.map(ig => {
	return <span 
	style={{
		    textTransform:'capitalize',
		     display: 'inline-block',
		      margin:'0 8px',
              border: '1px solid #ccc',
              padding:'5px'
		          }} 

	key={ig.key}> {ig.name} ({ig.amount})</span>
})
   return (
        <div className={Styles.Order}>
         <p>Ingredients: {ingredientOutput} </p>\
         <p>PRICE <strong>£{props.price.toFixed(2)} </strong></p>
        </div>
	
	)};

export default order;


// WEBPACK FOOTER //
// ./src/components/Order/Order.js